// Version 2 stores lightweight manifests and one bounded display photo per
// key. The upgrade clears legacy whole-array base64 caches, which could make
// iOS Safari terminate the worker page under memory pressure.
const DB_NAME = "ticket_photo_cache";
const STORE = "photos";
const DB_VERSION = 2;

function openDb() {
  return new Promise((resolve, reject) => {
    if (!("indexedDB" in window)) return reject(new Error("no indexedDB"));
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE);
      else req.transaction.objectStore(STORE).clear();
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function getCachedPhotos(key) {
  try {
    const db = await openDb();
    return await new Promise((resolve) => {
      const tx = db.transaction(STORE, "readonly");
      const req = tx.objectStore(STORE).get(key);
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => resolve(null);
    });
  } catch {
    return null;
  }
}

export async function setCachedPhotos(key, photos) {
  try {
    const db = await openDb();
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, "readwrite");
      tx.objectStore(STORE).put(photos, key);
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  } catch {
    // best-effort — a cache miss just falls back to a network fetch
  }
}

export const getCachedValue = getCachedPhotos;
export const setCachedValue = setCachedPhotos;

// True once this key holds a non-empty photo list on this device.
export async function hasCachedPhotos(key) {
  const v = await getCachedPhotos(key);
  return !!(v && v.length);
}

// Small sentinel so we only prefetch a closed ticket's photos once per device.
export const markPrefetched = (id) => setCachedPhotos(`__pf_${id}`, ["1"]);
export const wasPrefetched = (id) => hasCachedPhotos(`__pf_${id}`);

